import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { trackPageView } from '../lib/analytics';

export default function PageTracker() {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname + location.search, document.title);
  }, [location]);

  return null;
}
